import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
// import VueAxios from 'vue-axios';
import axios from 'axios';
import { config } from './config';
Vue.prototype.$axios = axios;
Vue.prototype.$config = config;

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
